export default {"src":"/_next/static/media/idea.2975ec86.svg","height":70,"width":51};